<template>
  <div class="container">
    <Modal :title="modalTitle" :show="modalVisible" @hideModal="hideModal" @submit="hideModal">
      <div class="announcement-modal-body">
        <p>近期公司接到群众反馈，有不法分子通过社交媒体平台冒用我司名义发布虚假信息。为打击违法犯罪行为，避免广大用户利益受损，公司特此澄清如下：</p>
        <p>1、我司从未在网站或社交媒体平台上以任何形式发布过"做任务赢取奖励"或类似信息，也未曾授权任何机构或个人实施此类行为。</p>
        <p>2、广大互联网用户应提高防骗意识，识别互联网上的虚假信息或诈骗信息，拒绝向陌生人透露个人信息及银行、财务信息。</p>
        <p>3、针对盗用我司名义在网上发布虚假信息或实施诈骗的行为，我司将依法追究相关人员的法律责任，积极维护网络环境，保护自身及广大用户权益。</p>
        <p>4、提醒广大用户通过我司官方渠道（官方网站、官方APP、官方微信公众号等）了解招聘信息、业务合作等事宜。如有自称我司员工的人员联系您，可拨打我司官方客服电话进行确认。请勿轻易点击来源不明的链接或下载不明来源的文件，以防感染病毒或泄露个人信息。</p>
        <p>如发现任何可疑行为或接到可疑电话、信息，请及时向当地公安机关报案，并将相关线索提供给我司。</p>
        <p>再次感谢广大用户对我司的信任与支持。我们将一如既往地为您提供优质、安全、可靠的服务。</p>
        <p>&nbsp;</p>
        <p style="text-align: right;">优矩互动（北京）科技有限公司</p>
        <p style="text-align: right;">2024年6月7日</p>
      </div>
    </Modal>
        <div class="page-header" :class="{'investor-page': $route.path === '/investor'}">
            <div class="center">
                <div class="logo">
                    <a href="/">
                        <img src="../../static/logo.png" />
                    </a>
                </div>
                <div class="nav-container">
                    <div class="link main-nav">
                        <a :class="$route.path === item.path?'on':''"  v-for="(item,index) in languageNav[language]" :key="index" :href="item.path">{{item.name}}</a>
                    </div>
                    <div class="link anchor-nav" v-if="$route.path === '/'">
                        <a href="javascript:void(0)" @click="scrollToSection('ujumedia1')">公司简介</a>
                        <a href="javascript:void(0)" @click="scrollToSection('ujumedia2')">发展历程</a>
                        <a href="javascript:void(0)" @click="scrollToSection('ujumedia3')">联系我们</a>
                    </div>
                    <div class="link investor-nav" v-if="$route.path === '/investor'">
                        <a href="javascript:void(0)" 
                           @click="scrollToInvestorSection('ujumedia'+(index+1))" 
                           v-for="(item,index) in investorSubNav[language]" 
                           :key="index">
                            {{item}}
                        </a>
                    </div>
                </div>
                <div class="language" v-if="$route.path !== '/investor'">
                    <b :class="language==='ch'?'on':''" @click="setLanguage('ch')">简</b>/
                    <b :class="language==='hk'?'on':''" @click="setLanguage('hk')">繁</b>/
                    <b :class="language==='en'?'on':''" @click="setLanguage('en')">English</b>
                </div>
            </div>
        </div>
        <div class="mobile-header">
            <div class="mobile-nav-container">
                <div class="mobile-logo">
                    <a href="/">
                        <img src="../../static/logo.png" />
                    </a>
                </div>
                <div class="mobile-nav-links">
                    <a v-for="(item,index) in languageNav[language]" 
                       :key="index" 
                       :href="item.path"
                       :class="$route.path === item.path ? 'active' : ''">
                        {{item.name}}
                    </a>
                </div>
                <div class="mobile-language">
                    <b :class="language==='ch'?'on':''" @click="setLanguage('ch')">简</b>
                    <b :class="language==='hk'?'on':''" @click="setLanguage('hk')">繁</b>
                    <b :class="language==='en'?'on':''" @click="setLanguage('en')">En</b>
                </div>
            </div>
        </div>
        <router-view :language="language" ref="routerView" />
        <div class="copyright">
            Copyrights © 2025. 优矩互动版权所有 <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备2021003454号-3</a>
        </div>
        <div class="gotop" @click="goTop"></div>
  </div>
</template>
<script>
import Modal from '../components/Modal.vue'
const setWithExpiry = (key, value, ttl) => {
  const now = new Date()

  // `item` is an object which contains the original value
  // as well as the time when it's supposed to expire
  const item = {
    value: value,
    expiry: now.getTime() + ttl
  }
  localStorage.setItem(key, JSON.stringify(item))
}
const getWithExpiry = key => {
  const itemStr = localStorage.getItem(key)
  // if the item doesn't exist, return null
  if (!itemStr) {
    return null
  }
  const item = JSON.parse(itemStr)
  const now = new Date()
  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key)
    return null
  }
  return item.value
}
const isModalVisible = () => {
  const modalVisible = getWithExpiry('modalVisible')
  if (modalVisible === null) {
    setWithExpiry('modalVisible', true, 1000 * 60 * 60 * 24 * 14)
    return true
  }
  return false
}

export default {
  components: {
    Modal
  },
  data () {
    return {
      modalTitle: '警惕网络诈骗，保护个人信息安全',
      modalVisible: isModalVisible(),
      language: this.$cookies.get('websiteLanguage') || 'ch',
      languageNav: {
        'ch': [{
          name: '首页',
          path: '/'
        }, {
          name: '投资者关系',
          path: '/investor'
        }],
        'hk': [{
          name: '首頁',
          path: '/'
        }, {
          name: '投資者關係',
          path: '/investor'
        }],
        'en': [{
          name: 'Home',
          path: '/'
        }, {
          name: 'Investor relations',
          path: '/investor'
        }]
      },
      investorSubNav: {
        'ch': [
          '公司资料',
          '公告及通函',
          '上市文件',
          '招股书',
          '财务报告',
          '企业管治',
          '投资者查询'
        ],
        'hk': [
          '公司資料',
          '公告及通函',
          '上市文件',
          '招股書',
          '財務報告',
          '企業管治',
          '投資者查詢'
        ],
        'en': [
          'Company Materials',
          'Announcements',
          'Listing Documents',
          'Prospectus',
          'Financial Reports',
          'Corporate Governance',
          'Investor Enquiries'
        ]
      }
    }
  },
  mounted() {
    // 添加滚动监听
    window.addEventListener('scroll', this.handleScroll)
    // 初始化滚动状态
    this.handleScroll()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    hideModal () {
        this.modalVisible = false
    },
    setLanguage (val) {
      this.language = val
      this.$cookies.set('websiteLanguage', val)
      this.$refs.routerView.getLanguage(val)
    },
    goTop () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    handleScroll() {
      const header = document.querySelector('.page-header')
      const mobileHeader = document.querySelector('.mobile-header')
      const gotop = document.querySelector('.gotop')
      
      if (window.scrollY > 100) {
        if (header) header.classList.add('scrolled')
        if (mobileHeader) mobileHeader.classList.add('scrolled')
        if (gotop) gotop.classList.add('show')
      } else {
        if (header) header.classList.remove('scrolled')
        if (mobileHeader) mobileHeader.classList.remove('scrolled')
        if (gotop) gotop.classList.remove('show')
      }
    },
    scrollToSection(sectionId) {
      console.log('尝试滚动到:', sectionId)
      setTimeout(() => {
        const element = document.getElementById(sectionId)
        if (element) {
          console.log('找到元素:', element, '位置:', element.offsetTop)
          const headerHeight = 100
          const viewportHeight = window.innerHeight // 获取视窗高度
          let top = element.offsetTop + viewportHeight - headerHeight
          
          // 如果计算出的位置是负数，则滚动到页面顶部
          if (top < 0) {
            top = 0
          }
          
          console.log('视窗高度:', viewportHeight, '滚动到位置:', top)
          window.scrollTo({
            top: top,
            behavior: 'smooth'
          })
        } else {
          console.error('找不到ID为', sectionId, '的元素')
        }
      }, 100)
    },
    scrollToInvestorSection(sectionId) {
      console.log('尝试滚动到投资者区域:', sectionId)
      setTimeout(() => {
        const element = document.getElementById(sectionId)
        if (element) {
          console.log('找到投资者元素:', element, '位置:', element.offsetTop)
          const headerHeight = 200 // 投资者页面需要考虑导航栏和子导航的高度
          let top = element.offsetTop - headerHeight
          
          // 如果计算出的位置是负数，则滚动到页面顶部
          if (top < 0) {
            top = 0
          }
          
          console.log('投资者页面滚动到位置:', top)
          window.scrollTo({
            top: top,
            behavior: 'smooth'
          })
        } else {
          console.error('找不到投资者页面ID为', sectionId, '的元素')
        }
      }, 100)
    }
  }
}
</script>

<style>
/* 重置样式 */
*{
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}

a{
    text-decoration: none;
}

html, body {
    height: 100%;
    margin: 0;
    padding: 0;
    scroll-behavior: smooth;
}

body{
    min-width: 1200px;
    overflow-x: auto;
    margin: 0;
    padding: 0;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    background: #ffffff;
    color: #333;
    line-height: 1.6;
}

.container{
    padding: 0;
    margin: 0;
    width: 100%;
}

/* 现代化透明导航栏 */
.page-header{
    display: block;
    height: 100px;
    background: transparent;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    z-index: 9999;
    transition: all 0.3s ease;
    padding: 20px 40px;
}

.page-header.scrolled {
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.center{
    max-width: none;
    width: 100%;
    margin: 0;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    height: 100%;
    background: transparent;
    backdrop-filter: none;
    -webkit-backdrop-filter: none;
    border-radius: 0;
    padding: 0;
    box-shadow: none;
    border: none;
    position: relative;
}

.logo{
    display: flex;
    align-items: center;
    padding: 10px 20px;
    transition: all 0.3s ease;
    position: absolute;
    left: 0;
    top: 0;
}

.logo img{
    height: 45px;
    width: auto;
    max-width: 220px;
    object-fit: contain;
    object-position: left center;
    transition: transform 0.3s ease;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}

/* 投资者页面导航居中 */
.investor-page .nav-container {
    left: 50% !important;
    right: auto !important;
    transform: translateX(-50%) !important;
    min-width: 500px !important; /* 投资者页面使用更紧凑的宽度 */
}

/* 非投资者页面保持原有布局 */
.nav-container {
    display: flex;
    align-items: center;
    gap: 15px;
    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border-radius: 25px;
    padding: 12px 20px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    transition: all 0.3s ease;
    position: absolute;
    left: 50%;
    top: 0;
    transform: translateX(-50%);
    max-width: none;
    width: auto;
    min-width: 600px;
    white-space: nowrap;
}

.page-header.scrolled .nav-container {
    background: rgba(255, 255, 255, 0.95);
    border: 1px solid rgba(0, 0, 0, 0.1);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.nav-container:hover {
    background: rgba(255, 255, 255, 0.25);
    transform: translateX(-50%) translateY(-2px);
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
}

.page-header.scrolled .nav-container:hover {
    background: rgba(255, 255, 255, 1);
    transform: translateX(-50%) translateY(-2px);
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
}

.link {
    display: flex;
    align-items: center;
    gap: 15px;
    background: transparent;
    backdrop-filter: none;
    -webkit-backdrop-filter: none;
    border-radius: 0;
    padding: 0;
    box-shadow: none;
    border: none;
    transition: none;
    position: static;
    left: auto;
    top: auto;
    transform: none;
}

.link:hover {
    background: transparent;
    transform: none;
    box-shadow: none;
}

.main-nav {
    border-right: 1px solid rgba(255, 255, 255, 0.3);
    padding-right: 15px;
    margin-right: 15px;
    white-space: nowrap; /* 防止主导航换行 */
    flex-shrink: 0; /* 防止收缩 */
}

.main-nav a {
    font-size: 14px; /* 统一使用较小字体 */
    padding: 6px 12px; /* 统一使用较小内边距 */
    white-space: nowrap; /* 防止单个链接换行 */
}

.anchor-nav {
    opacity: 0.8;
}

.investor-nav {
    opacity: 0.9;
    /* 移除左侧分割线 */
    /* border-left: 1px solid rgba(255, 255, 255, 0.3); */
    /* padding-left: 15px; */
    /* margin-left: 15px; */
    white-space: nowrap; /* 防止文字换行 */
    /* overflow-x: auto; 移除水平滚动避免闪现滚动条 */
    flex-shrink: 0; /* 防止收缩 */
}

/* 移除滚动后的分割线颜色设置 */
/* .page-header.scrolled .investor-nav {
    border-left-color: rgba(0, 0, 0, 0.1);
} */

.investor-nav a {
    font-size: 14px;
    padding: 6px 12px;
    white-space: nowrap; /* 防止单个链接文字换行 */
    flex-shrink: 0; /* 防止链接收缩 */
}

.link a{
    color: #ffffff;
    font-size: 14px; /* 统一使用较小字体 */
    font-weight: 600;
    letter-spacing: 0.5px;
    padding: 6px 12px; /* 统一使用较小内边距 */
    border-radius: 16px;
    transition: all 0.3s ease;
    position: relative;
    background: transparent;
    border: 1px solid transparent;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
    white-space: nowrap; /* 防止链接文字换行 */
    flex-shrink: 0; /* 防止链接收缩 */
}

.page-header.scrolled .link a {
    color: #2d3748;
    text-shadow: none;
}

.link a:hover{
    color: #ffffff;
    background: rgba(255, 255, 255, 0.2);
    border-color: rgba(255, 255, 255, 0.3);
    transform: scale(1.05);
    box-shadow: 0 4px 15px rgba(255, 255, 255, 0.2);
}

.page-header.scrolled .link a:hover {
    color: #667eea;
    background: rgba(102, 126, 234, 0.1);
    border-color: rgba(102, 126, 234, 0.2);
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.2);
}

.link a.on{
    color: #ffffff;
    background: rgba(255, 255, 255, 0.3);
    border-color: rgba(255, 255, 255, 0.4);
    box-shadow: 0 4px 15px rgba(255, 255, 255, 0.2);
}

.page-header.scrolled .link a.on {
    color: #667eea;
    background: rgba(102, 126, 234, 0.15);
    border-color: rgba(102, 126, 234, 0.3);
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.2);
}

.language{
    display: flex;
    align-items: center;
    gap: 4px; /* 减小间隙使布局更紧凑 */
    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    padding: 12px 20px;
    border-radius: 25px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    position: absolute;
    right: 0;
    top: 0;
    white-space: nowrap; /* 防止内容换行 */
    flex-shrink: 0; /* 防止收缩 */
}

.page-header.scrolled .language {
    background: rgba(255, 255, 255, 0.95);
    border: 1px solid rgba(0, 0, 0, 0.1);
}

.language:hover{
    background: rgba(255, 255, 255, 0.25);
    transform: translateY(-2px);
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
}

.page-header.scrolled .language:hover {
    background: rgba(255, 255, 255, 1);
}

.language b{
    color: #ffffff;
    font-weight: 600;
    cursor: pointer;
    padding: 6px 12px; /* 统一内边距 */
    border-radius: 12px;
    transition: all 0.3s ease;
    font-size: 14px; /* 统一字体大小 */
    border: 1px solid transparent;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
    white-space: nowrap; /* 防止换行 */
    flex-shrink: 0; /* 防止收缩 */
}

.page-header.scrolled .language b {
    color: #718096;
    text-shadow: none;
}

.language b:hover{
    color: #ffffff;
    background: rgba(255, 255, 255, 0.2);
    border-color: rgba(255, 255, 255, 0.3);
    transform: scale(1.05);
}

.page-header.scrolled .language b:hover {
    color: #667eea;
    background: rgba(102, 126, 234, 0.1);
    border-color: rgba(102, 126, 234, 0.2);
}

.language b.on{
    color: #ffffff;
    background: rgba(255, 255, 255, 0.3);
    border-color: rgba(255, 255, 255, 0.4);
    font-weight: 700;
    box-shadow: 0 2px 10px rgba(255, 255, 255, 0.2);
}

.page-header.scrolled .language b.on {
    color: #667eea;
    background: rgba(102, 126, 234, 0.15);
    border-color: rgba(102, 126, 234, 0.3);
    box-shadow: 0 2px 10px rgba(102, 126, 234, 0.2);
}

/* 移动端导航 */
.mobile-header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 80px;
    background: transparent;
    z-index: 1000;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    padding: 0 20px;
}

.mobile-header.scrolled {
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.mobile-nav-container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
}

.mobile-logo {
    flex-shrink: 0;
}

.mobile-logo img {
    height: 36px;
    width: auto;
    max-width: 140px;
    object-fit: contain;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
    transition: all 0.3s ease;
}

.mobile-header.scrolled .mobile-logo img {
    filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.05));
}

.mobile-nav-links {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
    justify-content: center;
}

.mobile-nav-links a {
    padding: 8px 12px;
    font-size: 14px;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.9);
    text-decoration: none;
    border-radius: 20px;
    transition: all 0.3s ease;
    white-space: nowrap;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
}

.mobile-header.scrolled .mobile-nav-links a {
    color: #4a5568;
    background: rgba(248, 250, 252, 0.8);
    border: 1px solid rgba(226, 232, 240, 0.5);
    text-shadow: none;
}

.mobile-nav-links a:hover,
.mobile-nav-links a.active {
    background: rgba(255, 255, 255, 0.25);
    color: #ffffff;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.mobile-header.scrolled .mobile-nav-links a:hover,
.mobile-header.scrolled .mobile-nav-links a.active {
    background: rgba(102, 126, 234, 0.1);
    color: #667eea;
    border-color: rgba(102, 126, 234, 0.3);
}

.mobile-language {
    display: flex;
    align-items: center;
    gap: 2px;
    flex-shrink: 0;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 16px;
    padding: 6px 8px;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
}

.mobile-header.scrolled .mobile-language {
    background: rgba(248, 250, 252, 0.8);
    border: 1px solid rgba(226, 232, 240, 0.5);
}

.mobile-language b {
    font-size: 12px;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.8);
    cursor: pointer;
    padding: 4px 6px;
    border-radius: 8px;
    transition: all 0.3s ease;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.mobile-header.scrolled .mobile-language b {
    color: #718096;
    text-shadow: none;
}

.mobile-language b:hover,
.mobile-language b.on {
    background: rgba(255, 255, 255, 0.2);
    color: #ffffff;
}

.mobile-header.scrolled .mobile-language b:hover,
.mobile-header.scrolled .mobile-language b.on {
    background: rgba(102, 126, 234, 0.1);
    color: #667eea;
}

/* 版权信息 */
.copyright{
    background: transparent;
    color: #718096;
    text-align: center;
    padding: 40px 20px;
    font-size: 14px;
    margin-top: 60px;
}

.copyright a{
    color: #667eea;
    text-decoration: none;
    transition: color 0.3s ease;
}

.copyright a:hover{
    color: #5a67d8;
}

/* 返回顶部按钮 */
.gotop{
    position: fixed;
    right: 40px;
    bottom: 40px;
    width: 48px;
    height: 48px;
    background: transparent;
    border: 2px solid #667eea;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transform: translateY(20px);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    z-index: 999;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
}

.gotop::after{
    content: '';
    width: 12px;
    height: 12px;
    border-top: 2px solid #667eea;
    border-right: 2px solid #667eea;
    transform: rotate(-45deg);
    margin-top: 3px;
    transition: all 0.3s ease;
}

.gotop:hover{
    transform: translateY(-3px) scale(1.05);
    border-color: #5a67d8;
    background: rgba(102, 126, 234, 0.1);
}

.gotop:hover::after{
    border-color: #5a67d8;
}

.gotop.show{
    opacity: 1;
    transform: translateY(0);
}

/* 模态框优化 */
.announcement-modal-body {
    line-height: 1.8;
    color: #4a5568;
    max-height: 60vh;
    overflow-y: auto;
}

.announcement-modal-body p {
    margin-bottom: 16px;
    font-size: 15px;
}

/* 移动端适配 */
@media screen and (max-width: 1200px) {
    .center {
        padding: 0 20px;
    }
}

@media screen and (max-width: 768px) {
    body {
        min-width: auto; /* 移动端取消最小宽度限制 */
        overflow-x: hidden; /* 移动端隐藏水平滚动条 */
    }
    
    .page-header {
        display: none;
    }
    
    .mobile-header {
        display: flex;
    }
    
    .gotop {
        right: 20px;
        bottom: 20px;
        width: 44px;
        height: 44px;
    }
    
    .copyright {
        padding: 30px 20px;
        font-size: 13px;
    }
}

/* 响应式设计 */
@media screen and (max-width: 750px) {
    .page-header {
        display: none;
    }
    
    .mobile-header {
        display: flex;
    }
    
    .mobile-header .center {
        margin: 0;
        max-width: none;
    }
    
    /* 移动端投资者页面调整 */
    .investor-sub-nav {
        display: block;
    }
}

@media screen and (min-width: 751px) {
    .mobile-header {
        display: none;
    }
    
    .page-header {
        display: block;
    }
    
    /* 桌面端隐藏移动端投资者子导航 */
    .investor-sub-nav {
        display: block;
    }
}

/* 桌面端特定样式优化 */
@media screen and (min-width: 1200px) {
    .center {
        padding: 0 40px;
    }
    
    .link {
        gap: 40px;
    }
}

/* 移动端切换断点 */
@media screen and (max-width: 1200px) {
    .investor-nav {
        display: none; /* 在较小屏幕上隐藏，依赖移动端菜单 */
    }
    
    .nav-container {
        padding: 12px 16px;
    }
    
    .main-nav {
        padding-right: 12px;
        margin-right: 12px;
    }
}

/* 小屏幕电脑自适应 - 确保优先级 */
/* 极小屏幕 (1201px - 1250px) */
@media screen and (max-width: 1250px) and (min-width: 1201px) {
    .page-header {
        padding: 15px 20px !important;
    }
    
    .nav-container {
        min-width: 420px !important;
        gap: 8px !important;
        padding: 8px 12px !important;
    }
    
    /* 投资者页面特殊调整 */
    .investor-page .nav-container {
        min-width: 380px !important;
    }
    
    .link {
        gap: 8px !important;
    }
    
    .main-nav {
        padding-right: 8px !important;
        margin-right: 8px !important;
    }
    
    .link a {
        font-size: 11px !important;
        padding: 4px 6px !important;
    }
    
    .main-nav a {
        font-size: 11px !important;
        padding: 4px 6px !important;
    }
    
    .investor-nav a {
        font-size: 11px !important;
        padding: 4px 5px !important;
    }
    
    .language {
        padding: 8px 12px !important;
        gap: 2px !important;
    }
    
    .language b {
        font-size: 11px !important;
        padding: 4px 5px !important;
    }
}

/* 小屏幕 (1251px - 1300px) */
@media screen and (max-width: 1300px) and (min-width: 1251px) {
    .page-header {
        padding: 15px 20px !important;
    }
    
    .nav-container {
        min-width: 480px !important;
        gap: 10px !important;
        padding: 8px 14px !important;
    }
    
    /* 投资者页面特殊调整 */
    .investor-page .nav-container {
        min-width: 440px !important;
    }
    
    .link a {
        font-size: 12px !important;
        padding: 4px 8px !important;
    }
    
    .main-nav a {
        font-size: 12px !important;
        padding: 4px 8px !important;
    }
    
    .investor-nav a {
        font-size: 12px !important;
        padding: 4px 6px !important;
    }
    
    .language {
        padding: 8px 14px !important;
        gap: 2px !important;
    }
    
    .language b {
        font-size: 12px !important;
        padding: 4px 6px !important;
    }
}

/* 中等屏幕 (1301px - 1400px) */
@media screen and (max-width: 1400px) and (min-width: 1301px) {
    .page-header {
        padding: 20px 30px !important;
    }
    
    .nav-container {
        min-width: 540px !important;
        gap: 12px !important;
        padding: 10px 16px !important;
    }
    
    /* 投资者页面特殊调整 */
    .investor-page .nav-container {
        min-width: 480px !important;
    }
    
    .link a {
        font-size: 13px !important;
        padding: 5px 10px !important;
    }
    
    .main-nav a {
        font-size: 13px !important;
        padding: 5px 10px !important;
    }
    
    .investor-nav a {
        font-size: 13px !important;
        padding: 5px 8px !important;
    }
    
    .language {
        padding: 10px 16px !important;
        gap: 3px !important;
    }
    
    .language b {
        font-size: 13px !important;
        padding: 5px 8px !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/view/App.vue